import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, pimsService } from '@v2/services';
import type { UpdatePimsConfigPayload } from '@v2/types';

interface UseUpdatePimsConfigResult {
  updateConfig: (payload: UpdatePimsConfigPayload) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export const useUpdatePimsConfig = (): UseUpdatePimsConfigResult => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: pimsService.updateConfig,
    onSuccess: (_data, payload) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pims.detail(payload.entityId) });
      queryClient.invalidateQueries({
        queryKey: queryKeys.configurations.byPims(payload.entityId),
      });
    },
  });

  return {
    updateConfig: mutation.mutateAsync,
    loading: mutation.isPending,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useUpdatePimsConfig;
